import { pipe } from "./composition.js";
import { pairRight } from "./juxt.js";
import { isPromise } from "./promise.js";
import { currentLocation } from "./trace.js";
export const sideLog = (x) => {
    console.log(currentLocation(3), x);
    return x;
};
export const sideLogJson = (x) => {
    console.log(currentLocation(3), JSON.stringify(x, null, 2));
    return x;
};
export const logAround = (f) => {
    const codeLocation = currentLocation(3);
    return ((...xs) => {
        console.log(codeLocation, xs.length === 1 ? xs[0] : xs);
        const output = f(...xs);
        if (isPromise(output)) {
            return output.then((x) => {
                console.log(codeLocation, x);
                return x;
            });
        }
        console.log(codeLocation, output);
        return output;
    });
};
export const logAfter = (f) => {
    const codeLocation = currentLocation(3);
    return ((...xs) => {
        const output = f(...xs);
        if (isPromise(output)) {
            return output.then((x) => {
                console.log(codeLocation, x);
                return x;
            });
        }
        console.log(codeLocation, output);
        return output;
    });
};
export const logBefore = (f) => {
    const codeLocation = currentLocation(3);
    return ((...xs) => {
        console.log(codeLocation, xs.length === 1 ? xs[0] : xs);
        const output = f(...xs);
        if (isPromise(output)) {
            return output.then((x) => {
                return x;
            });
        }
        return output;
    });
};
const getTimestampMilliseconds = () => new Date().getTime();
export const timeit = (handler, f) => ((...x) => {
    const started = getTimestampMilliseconds();
    const result = f(...x);
    if (isPromise(result)) {
        return result.then((result) => {
            const elapsed = getTimestampMilliseconds() - started;
            handler(elapsed, x, result);
            return result;
        });
    }
    const elapsed = getTimestampMilliseconds() - started;
    handler(elapsed, x, result);
    return result;
});
export const assert = (condition, errorMessage) => 
// @ts-expect-error not sure
pipe(
// @ts-expect-error not sure
pairRight(condition), ([value, passed]) => {
    if (!passed)
        throw new Error(errorMessage);
    return value;
});
export const coerce = (x) => {
    if (x === undefined || x === null) {
        throw new Error(`Got ${x} where value was expected.`);
    }
    return x;
};
export const tryCatch = 
// deno-lint-ignore no-explicit-any
(fallback) => 
// deno-lint-ignore no-explicit-any
(f) => ((...x) => {
    try {
        const result = f(...x);
        return isPromise(result)
            ? result.catch((e) => fallback(e, ...x))
            : result;
    }
    catch (e) {
        return fallback(e, ...x);
    }
});
export const catchWithNull = tryCatch(() => null);
const makeErrorWithId = (id) => {
    const err = new Error();
    // @ts-expect-error changes the typing of `Error`
    err.id = id;
    return err;
};
const handleAsyncOrSyncException = (f, params, onExcept) => {
    try {
        const result = f(...params);
        if (isPromise(result)) {
            return result.catch(onExcept);
        }
        return result;
    }
    catch (e) {
        // @ts-ignore does not trigger in node
        return onExcept(e);
    }
};
const catchErrorWithIdAndValue = (id) => 
// deno-lint-ignore no-explicit-any
(fallback) => (f) => (...xs) => handleAsyncOrSyncException(f, xs, (e) => {
    if (e.id === id)
        return fallback(e.payload);
    throw e;
});
const catchErrorWithId = (id) => (fallback) => (f) => (...xs) => handleAsyncOrSyncException(f, xs, (e) => {
    if (e.id === id)
        return fallback(...xs, e);
    throw e;
});
export const throwerCatcher = () => {
    const id = crypto.randomUUID();
    const catcher = catchErrorWithId(id);
    const thrower = () => {
        throw makeErrorWithId(id);
    };
    return { thrower, catcher };
};
export const throwerCatcherWithValue = () => {
    const id = crypto.randomUUID();
    const catcher = catchErrorWithIdAndValue(id);
    const thrower = (value) => {
        const e = makeErrorWithId(id);
        // @ts-expect-error This code has a distinct type of `Error`
        e.payload = value;
        throw e;
    };
    return { thrower, catcher };
};
